import { disableBodyScroll, clearAllBodyScrollLocks } from 'body-scroll-lock'
import scrollToElement from 'scroll-to-element'

export const mobileBurger = () => {
  const mobileMenuBtn = document.querySelector('.header-mob__btn button')
  const mobileMenu = document.querySelector('.header__mobile-menu')
  const body = document.querySelector('body')
  const mobileBanner = document.querySelector('.banner_mobile') as HTMLElement

  mobileMenuBtn?.addEventListener('click', function () {
    if (body && mobileMenuBtn && mobileMenu) {
      mobileMenuBtn.classList.toggle('open')
      body.classList.toggle('open')

      if (mobileMenu.classList.contains('open')) {
        mobileMenu.classList.remove('animated')
        if (mobileBanner) {
          mobileBanner.style.margin = '0px 0 0 0'
        }
        setTimeout(function () {
          mobileMenu.classList.remove('open')
        }, 400)
        clearAllBodyScrollLocks()
      } else {
        scrollToElement('html')
        disableBodyScroll(body)
        mobileMenu.classList.add('open')
        if (mobileBanner) {
          mobileBanner.style.margin =
            '-' + mobileBanner.clientHeight + 'px 0 0 0'
        }

        setTimeout(function () {
          mobileMenu.classList.add('animated')
        }, 100)
      }
    }
  })
}
